import { createAction, props } from '@ngrx/store';

// Interfaces
import { CheckboxOption } from 'Angular/features/components/inputs/checkbox-group/interfaces/checkbox-option.interface';

export const setComplianceReportTypeOption = createAction(
    '[Compliance Report History Page] Set Report Type Option',
    props<{ reportTypeOption: CheckboxOption }>()
);
